"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENT_TYPE_LABELS = void 0;
exports.ATTACHMENT_TYPE_LABELS = {
    1: {
        plural: "Periodical Statements",
        singular: "Periodical Statement",
    },
    2: {
        plural: "Bunker Delivery Notes",
        singular: "Bunker Delivery Note",
    },
};
